import { render, staticRenderFns } from "./ItemRedemptionForm.vue?vue&type=template&id=453db9c4&scoped=true"
import script from "./ItemRedemptionForm.vue?vue&type=script&lang=js"
export * from "./ItemRedemptionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453db9c4",
  null
  
)

export default component.exports